export const sitemap = [
  [
    {
      label: "Company",
      slug: "https://invest.myxeno.com/company",
    },
    {
      label: "Terms of use",
      slug: "https://myxeno.com/terms-of-use",
    },
    {
      label: "Privacy Policy",
      slug: "https://myxeno.com/privacy-policy",
    },
    {
      label: "Client Agreement",
      slug: "https://myxeno.com/client-agreement",
    },
  ],
]
